import SearchBar from "./SeachBar";
import SideBarCtrlButton from "./SideBarCtrlButton";

const ToolBarLeftContainer = ({pcSideBarShow, 
                                setPcSideBarShow,
                                mobSideBarShow,
                                setMobSideBarShow}) =>{
    return (
        <ul className="list-unstyled">
            <li>
                <SideBarCtrlButton
                    pcSideBarShow={pcSideBarShow}
                    setPcSideBarShow={setPcSideBarShow}
                    mobSideBarShow={mobSideBarShow}
                    setMobSideBarShow={setMobSideBarShow}/>
            </li> 
            <li>
                <SearchBar/> 
            </li>
        </ul>
    )
}

export default ToolBarLeftContainer;